import { render, staticRenderFns } from "./JohariItem.vue?vue&type=template&id=40e28428&"
import script from "./JohariItem.vue?vue&type=script&lang=js&"
export * from "./JohariItem.vue?vue&type=script&lang=js&"
import style0 from "./JohariItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports